import { useLayoutEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import GetInTouch from "../components/gettouch"
import PartnersCards from "../components/card-partner";


import banner from "../assets/image/Partner/Partner-Midpage-large-image.png"


gsap.registerPlugin(ScrollTrigger);

export default function Partners() {
 const heroRef = useRef();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {

      // ===============================
      // HERO HEADLINES INTRO ANIMATION
      // ===============================
      const tl = gsap.timeline({ defaults: { ease: "power4.out" } });

      tl.from(".is-a-wrap--1 .h1-s", { yPercent: 120, duration: 1 })
        .from(".is-a-wrap-2 .h1-ss", { yPercent: 120, duration: 1 }, "-=0.8")
        .from(".is-a-wrap-3 .h1-s", { yPercent: 120, duration: 1 }, "-=0.8")
        .from(".is-a-wrap-4 .h1-ss", { yPercent: 120, duration: 1 }, "-=0.8");

      // ===============================
      // SUBTEXT + IMAGE REVEAL
      // ===============================
      gsap.from(".text", {
        opacity: 0,
        y: 40,
        duration: 1,
        delay: 0.5
      });

      gsap.from(".ab-img-1", {
        scale: 1.3,
        yPercent: 20,
        duration: 2,
        ease: "power3.out"
      });

      // ===============================
      // SCROLL HEADING ROW PARALLAX
      // ===============================
      gsap.to(".is-row-6", {
        xPercent: 10,
        scrollTrigger: {
          trigger: ".is-row-6",
          start: "top bottom",
          scrub: true
        }
      });

      gsap.to(".is-row-4", {
        xPercent: -10,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top bottom",
          scrub: true
        }
      });


      gsap.to(".is-a-wrap--1", {
  x: "10em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

gsap.to(".is-a-wrap-2", {
  x: "-6.7em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

gsap.to(".is-a-wrap-3", {
  x: "-11.7em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

gsap.to(".is-a-wrap-4", {
  x: "6.7em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }});

      // ===============================
      // TEAM IMAGES POP IN
      // ===============================
      gsap.from(".sm-team-img-wrap", {
        scale: 0,
        y: 60,
        opacity: 0,
        stagger: 0.15,
        duration: 1,
        scrollTrigger: {
          trigger: ".is-sm-team-wrap",
          start: "top 80%"
        }
      });

      // ===============================
      // CERTIFICATE TEXT REVEAL
      // ===============================
      gsap.from(".cert-txt", {
        yPercent: 120,
        stagger: 0.1,
        duration: 0.8,
        scrollTrigger: {
          trigger: ".certificate-wrapper",
          start: "top 80%"
        }
      });

    }, heroRef);

    return () => ctx.revert();
  }, []);


  const specialiseRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

      // ROWS PARALLAX (subtle horizontal drift)
      gsap.from(".is-row-1", {
        xPercent: 4,
        scrollTrigger: {
          trigger: ".is-row-1",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-2", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-2",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-3", {
        xPercent: -2,
        scrollTrigger: {
          trigger: ".is-row-3",
          start: "top 85%",
          scrub: 1
        }
      });

      gsap.from(".is-row-4", {
        xPercent: 2,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top 85%",
          scrub: 1
        }
      });

      // TEXT REVEAL (up & down alternating)
      gsap.from(".h2", {
        y: -120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: specialiseRef.current,
          start: "top 75%"
        }
      });

      gsap.from(".h2-stroke", {
        y: 120,
        opacity: 0,
        duration: 1,
        stagger: 0.15,
        scrollTrigger: {
          trigger: specialiseRef.current,
          start: "top 75%"
        }
      });

gsap.from(".sm-anim-wrapper", {
  x: -120,
  opacity: 0,
  duration: 1,
   stagger: 0.15,
  ease: "none",
  scrollTrigger: {
    trigger: ".h-scroll-card",
    start: "top 85%",   
    toggleActions: "play none none none"
  }
});

    }, specialiseRef);

    return () => ctx.revert();
  }, []);



    return(
        <div className="main-wrapper">
           <section ref={heroRef} className="hero-100 is-aout-hero">
              <div className="container-lg is-serv-hero">
                <div className="flex-l-c">
                  <div className="h1-s-wrap is-a-wrap--1">
                    <h1 className="h1-s">OUR PARTNERS World-Class</h1>
                  </div>
                </div>

                <div className="flex-r-s">
                  <div className="h1-s-wrap is-a-wrap-2">
                    <h1 className="h1-ss">Technology. Local Execution.</h1>
                  </div>
                </div>

                {/* <div className="flex-cc">
                  <div className="h1-s-wrap is-a-wrap-3">
                    <h1 className="h1-s"></h1>
                  </div>
                </div>

                <div className="flex-l-s">
                  <div className="h1-s-wrap is-a-wrap-4">
                    <h1 className="h1-ss">Local Execution.</h1>
                  </div>
                </div> */}
                <div className="container-lg is-sub-headline">
                  <div className="d-50 is-about-mobile">
                    <p className="text">
                        PthruP doesn't work alone. We have <strong>deliberately built</strong> relationships with a small group of technology leaders, specialists, and innovators — each chosen because they are genuinely the best at what they do within the FoodSafe ecosystem. We don't partner widely. We partner carefully. Every name on this page has been selected because they make our customers' facilities safer, cleaner, and more productive.
                    </p>
                  </div>
                </div>
              </div>


               <div className="container-lg is-serv-hero is-mobile">
                <div className="flex-l-c">
                  <div className="h1-s-wrap is-a-wrap--1">
                    <h1 className="h1-s">OUR PARTNERS</h1>
                  </div>
                </div>

                <div className="flex-r-s">
                  <div className="h1-s-wrap is-a-wrap-2">
                    <h1 className="h1-ss">World-Class</h1>
                  </div>
                </div>

                <div className="flex-cc">
                  <div className="h1-s-wrap is-a-wrap-3">
                    <h1 className="h1-s">Technology.</h1>
                  </div>
                </div>

                <div className="flex-l-s">
                  <div className="h1-s-wrap is-a-wrap-4">
                    <h1 className="h1-ss">Local</h1>
                  </div>
                </div>
                 <div className="flex-l-s">
                  <div className="h1-s-wrap is-a-wrap-5">
                    <h1 className="h1-ss">Execution.</h1>
                  </div>
                </div>
                <div className="container-lg is-sub-headline">
                  <div className="d-50 is-about-mobile">
                    <p className="text">
                        PthruP doesn't work alone. We have deliberately built relationships with a small group of technology leaders, specialists, and innovators — each chosen because they are genuinely the best at what they do within the FoodSafe ecosystem. We don't partner widely. We partner carefully. Every name on this page has been selected because they make our customers' facilities safer, cleaner, and more productive.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <PartnersCards/>
          

    <div className="above-footer-section" ref={specialiseRef}>
        <div className="section is-no-pad">
    <div className="banner-img is-service">
        <div className="img-child">
            <div className="banner-img-frame">
                <img src={banner} className="banner-frame-gray" alt="banner-img-frame"/>
                {/* <div className="bn-img is-1"></div>
                <div className="bn-img is-2"></div> */}
            </div>
        </div>
        <div className="banner-text-wrapper">
            <p className="text txt-white">    They are a deliberate network assembled over years, tested in real projects, and chosen because together we can offer Indian poultry processors something no single company can: a complete, integrated FoodSafe ecosystem backed by the best technology and expertise in the world.</p>
        </div>
        <div className="container-lg is-banner">
            <div className="h-row is-center">
                <div className="img-marq-flex is-b-1">
                    <h2 className="img-marq-txt is-fill">Our</h2>
                </div>
                <div className="img-marq-flex is-b-1-l-space">
                    <h2 className="img-marq-txt is-fill">partners</h2>
                </div>
            </div>
            <div className="h-row is-right">
                <div className="img-marq-flex is-b-2">
                    <h2 className="img-marq-txt is-stroke"> are not a directory.</h2>
                </div>
            </div>
            {/* <div className="h-row is-no-move is-top">
                <div className="img-marq-flex is-b-3">
                    <h2 className="img-marq-txt is-fill">a directory.</h2>
                </div>
               
            </div> */}
        </div>
        <div className="container-lg is-banner is-mobile">
            <div className="h-row is-split">
                <div className="img-marq-flex is-b-1">
                    <h2 className="img-marq-txt is-fill">Our partners</h2>
                </div>
            </div>
            {/* <div className="h-row is-row-right">
               
                <div className="img-marq-flex is-b-2">
                    <h2 className="img-marq-txt is-stroke"> are not</h2>
                </div>
            </div> */}
            <div className="h-row is-img-text-3">
                <div className="img-marq-flex is-b-3">
                    <h2 className="img-marq-txt is-fill">are not a directory.</h2>
                </div>
            </div>
            {/* <div className="h-row is-no-move is-top">
                <div className="img-marq-flex is-b-4">
                    <h2 className="img-marq-txt is-stroke">Requirements</h2>
                </div>
            </div> */}
        </div>
    </div>
</div>
    </div>

<GetInTouch/>
          </div>
    )
}